module.exports = __webpack_public_path__ + "static/media/activity.80f69584.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/activity.png
// module id = 1027
// module chunks = 2